import { Routes } from '@angular/router';

export const routes: Routes = [ 
  {
    path: '', children: [
      {
        path: '',
        loadComponent: () => import('./offers.component').then(m => m.OffersComponent),
        data: {
          title: "KudosHub | Offers",
          description: "",
          keywords: "email list validation",
          ogTitle: "KudosHub | Offers",
          ogDesc: "",
          ogImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
          ogUrl: "https://kudoshub.com/offers",
          twitterTitle: "KudosHub | Offers",
          twitterDesc: "",
          twitterImage: "https://kudoshub.com/theme/images/og-images/logo.webp",
        },
      }
    ]
  }
];
